<template>
    <div class="calc" v-if="!isFetchingLocales">
        <div class="tabs">
            <div class="tabs__header">
                <div
                    class="tabs__header-item"
                    @click="setActiveTab(0)"
                    :class="[ activeTab === 0 ? 'tabs__header-item_active' : '' ]"
                >
                    <span class="show_sm">{{ $t('calc.payinTabTitle') }}</span>
                    <span class="hide_sm">{{ $t('calc.payinTabTitleShort') }}</span>
                </div>

                <div
                    class="tabs__header-item"
                    @click="setActiveTab(1)"
                    :class="[ activeTab === 1 ? 'tabs__header-item_active' : '' ]"
                >
                    <span class="show_sm">{{ $t('calc.payoutTabTitle') }}</span>
                    <span class="hide_sm">{{ $t('calc.payoutTabTitleShort') }}</span>
                </div>
            </div>

            <div class="tabs__content">
                <transition name="slide">
                    <div
                        class="box tabs__content-item"
                        v-if="activeTab === 0"
                    >
                        <PayIn />
                    </div>
                </transition>
                <transition name="slide">
                    <div
                        class="box tabs__content-item"
                        v-if="activeTab === 1"
                    >
                        <PayOut />
                    </div>
                </transition>
            </div>
        </div>
    </div>
    <Preloader v-else />
</template>

<script>
import { mapGetters } from 'vuex'

import { ACTIONS as ACTIONS_CALC } from '../../store/calc'

import PayIn from './payin'
import PayOut from './payout'
import Preloader from '../../components/ui/preloader'

export default {
    name: 'Calc',

    components: {
        PayIn,
        PayOut,
        Preloader,
    },

    data: () => {
        return {
            activeTab: 0,
        }
    },

    computed: {
        ...mapGetters([
            'isFetchingLocales'
        ])
    },

    mounted() {},

    methods: {
        setActiveTab(index) {
            this.activeTab = index

            this.$store.dispatch(ACTIONS_CALC.CLEAR_STATE)
        },
    },
}
</script>

<style lang='scss' scoped>
.calc {
    margin: 30px 0;
    background-color: rgba(38, 38, 38, 1);
    border-radius: 3px;
}

.box {
    padding: 15px;
}

.tabs {
    &__header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgba(53, 53, 53, 1);

        &-item {
            flex-grow: 1;
            text-align: center;
            color: #fff;
            text-transform: uppercase;
            line-height: 18px;
            padding: 24px 0;
            position: relative;
            cursor: pointer;
            user-select: none;

            &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 0;
                background-image: linear-gradient(-90deg, rgba(245, 156, 7, 1) 0%, rgba(245, 117, 7, 1) 100%);
                transition: all .2s;
            }

            &_active {
                cursor: default;

                &:after {
                    height: 2px;
                }
            }
        }
    }

    &__content {
        position: relative;

        &-item {
            // background-color: #262626;
            transition: all .3s;
        }
    }
}


.slide-enter {
    opacity: 0;
}
.slide-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
}

.tabs__content-item.slide-enter:nth-child(2) {transform: translateX(20px);}
.tabs__content-item.slide-leave-active:nth-child(1) {transform: translateX(-20px);}

.tabs__content-item.slide-enter:nth-child(1) {transform: translateX(-20px);}
.tabs__content-item.slide-leave-active:nth-child(2) {transform: translateX(20px);}

</style>
